import styled from "styled-components";
import {themecolors} from "../utils/themecolors";

const Form = styled.form`
  width: 100%;
  & > input[type="text"],
  & > input[type="password"] {
    width: 100%;
    border: none;
    padding: 12px 16px;
    margin-bottom: 16px;
    border-radius: 6px;
  }
  & > label {
    display: block;
    margin-bottom: 4px;
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
  }
  a {
    font-weight: 500;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text: theme.blue_1};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Legal = styled.div`
  width: 100%;
  margin-bottom: 16px;
  input[type=checkbox] {
    margin-right: 12px;
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
  & > label {
    display: block;
    font-size: 13px;
    font-weight: 400;
    text-transform: none;
  }
`;

export default Form;
